import { EventEmitter, OnChanges, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PageGuideService } from '../../../../page-guide/page-guide.service';
import { Menu } from '../../../menu/menu.model';
import { MenuHoverEvent } from '../menu-hover-event.model';
import { MenuService } from '../menu.service';
import { FullMenuService } from '@app/full-menu/full-menu.service';
var MenuCategoryComponent = /** @class */ (function () {
    function MenuCategoryComponent(translate, menuService, pageGuideService, fullMenuService) {
        if (translate === void 0) { translate = null; }
        this.translate = translate;
        this.menuService = menuService;
        this.pageGuideService = pageGuideService;
        this.fullMenuService = fullMenuService;
        this.showAllOptions = new EventEmitter();
        this.clickHideMenu = new EventEmitter();
    }
    MenuCategoryComponent.prototype.ngOnInit = function () {
        this.availableCategories = [];
    };
    MenuCategoryComponent.prototype.ngOnChanges = function () {
        if (this.category)
            this.availableCategories = this.prepareAvailableCategories();
    };
    MenuCategoryComponent.prototype.openFullMenu = function () {
        this.onShowAllOptions(true);
        this.menuService.fullMenu(this.translate.currentLang, this.category.name.toLowerCase());
        this.fullMenuService.setMenuTabindex(this.initialIndex);
    };
    MenuCategoryComponent.prototype.onShowAllOptions = function (event) {
        this.fullMenuService.setMenuTabindex(this.initialIndex);
        this.showAllOptions.emit(event);
    };
    MenuCategoryComponent.prototype.prepareAvailableCategories = function () {
        var filledMenuOptions = [];
        if (this.category.categories) {
            this.category.categories.forEach(function (option) {
                if (option.subMenus !== null)
                    filledMenuOptions.push(option);
            });
        }
        return filledMenuOptions;
    };
    Object.defineProperty(MenuCategoryComponent.prototype, "menuCategoryId", {
        get: function () {
            return this.category.name.toLowerCase() + 'MenuCategory';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuCategoryComponent.prototype, "menuCategoryFullMenuId", {
        get: function () {
            return this.category.name.toLowerCase() + 'MenuCategoryFullMenu';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuCategoryComponent.prototype, "showMenuOptions", {
        get: function () {
            if (!this.menuIndex)
                return false;
            if (!this.show)
                return false;
            if (this.pageGuideService.isPageGuideActive && !this.isFullMenuGuied)
                return false;
            return this.menuIndex === this.show.index && this.show.buttonIsHovered && !this.show.searchBarIsFocused;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuCategoryComponent.prototype, "categoryHasOptions", {
        get: function () {
            if (!this.category)
                return false;
            if (!this.category.categories)
                return false;
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuCategoryComponent.prototype, "isMenuBlocked", {
        get: function () {
            return this.pageGuideService.isPageGuideActive && this.isFullMenuGuied;
        },
        enumerable: true,
        configurable: true
    });
    MenuCategoryComponent.prototype.focusOut = function () {
        if (this.lastMenu) {
            this.clickHideMenu.emit("");
        }
    };
    MenuCategoryComponent.prototype.focus = function () {
        console.log("recebeu o foco");
    };
    MenuCategoryComponent.prototype.onOpenMenu = function (url) {
        this.clickHideMenu.emit(url);
    };
    return MenuCategoryComponent;
}());
export { MenuCategoryComponent };
